import Cookies from 'js-cookie';
// import getTagDigitalID from '../utils/analytics';
import * as HTTP_REQUEST from '../utils/http';
import {
  getClientPath,
  getPlansPath,
  validatePolizaPath,
  cookiesPath,
  validateSinisterPath,
  createQuotePath,
  leadPath,
  addThirdPath,
  validatePreExistingPath,
  getDepartamentsPath,
  getProvincesPath,
  getDistrictsPath,
  validateImcPath,
  planSelectionPath,
  sessionPath,
  registerDpsPath,
  susDpsPath,
  dpsUploadPath,
  dpsRoutePath,
  sendNotificationPath,
  sendEmailPath,
  calculatePath,
  getClientVCPath,
  validateClientVCPath,
  sendEmisionPath,
  getPlansQuotePath,
  validateSubscription,
} from '../utils/url';

export const abortRequest = async (promiseToCancel, reason) => {
  if (promiseToCancel) {
    HTTP_REQUEST.cancel(promiseToCancel, reason);
  }
};

export const getPersonDataCV = async (dataIn = {}) => {
  const person = await HTTP_REQUEST.post({
    path: getClientVCPath,
    data: dataIn,
    name: 'CANALVIDA',
    amplifyType: 'CANALVIDA',
    action: 'getPersonDataCV',
  });
  return person.payload;
};

export const validatePersonCV = async (dataIn = {}, sendSignal = () => {}) => {
  const person = await HTTP_REQUEST.post({
    path: validateClientVCPath,
    data: dataIn,
    name: 'CANALVIDA',
    amplifyType: 'CANALVIDA',
    action: 'validatePersonCV',
    sendSignal,
  });
  return person.payload;
};

export const getPersonData = async (dataIn = {}) => {
  const person = await HTTP_REQUEST.post({
    path: getClientPath,
    data: dataIn,
    name: 'CORE',
    action: 'getPersonData',
  });
  return person.payload;
};

export const getOneStepInfo = async ({ id }) => {
  const data = await HTTP_REQUEST.get({
    path: `/one-step/cotizaciones/${id}`,
    action: 'getOneStepInfo',
  });
  return data.payload;
};

export const getPlanData = async (data) => {
  const plan = await HTTP_REQUEST.get({
    path: getPlansPath,
    payload: data,
    action: 'getPlanData',
  });
  return plan.payload;
};

export const getPlansQuoteData = async (data, sendSignal) => {
  const plan = await HTTP_REQUEST.post({
    path: getPlansQuotePath,
    data,
    name: 'SALFLEX',
    amplifyType: 'SALUD',
    action: 'getPlansQuoteData',
    sendSignal,
  });
  return plan.payload;
};

export const validatePolicy = async (data = {}) => {
  const response = await HTTP_REQUEST.post({
    path: validatePolizaPath,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'validatePolicy',
  });
  return response.payload;
};

export const createDigitalId = async (data = {}) => {
  try {
    const response = await HTTP_REQUEST.post({
      path: cookiesPath,
      data,
      name: 'CORE',
      amplifyType: 'SALUD',
      action: 'createDigitalId',
    });
    if (response?.payload.id !== null && !window.location.href.includes('localhost')) {
      Cookies.set('audience.authstate', true, { expires: 1, path: '/' }, { domain: '.rimac.com' });
      Cookies.set('audience.digital_id', response.payload.id, { expires: 1, path: '/' }, { domain: '.rimac.com' });
      // getTagDigitalID(response.payload.id);
    }
    return response.payload.id;
  } catch (error) {
    return null;
  }
};

export const validateSinister = async (data = {}, sendSignal = () => {}) => {
  const response = await HTTP_REQUEST.post({
    data,
    name: 'CORE',
    path: validateSinisterPath,
    amplifyType: 'CORE',
    action: 'validateSinister',
    sendSignal,
  });
  return response;
};

export const validateIMC = async (data = {}, sendSignal = () => {}) => {
  const response = await HTTP_REQUEST.post({
    data,
    name: 'CORE',
    path: validateImcPath,
    amplifyType: 'CORE',
    action: 'validateIMC',
    sendSignal,
  });
  return response;
};

/* eslint-disable */
export const registerLead = async (data = {}, sendSignal = () => {}) => {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      if (data[key] === null || data[key] === '') {
        delete data[key];
      }
    }
  }

  const { response } = await HTTP_REQUEST.post({
    data,
    name: 'LEAD',
    path: leadPath,
    amplifyType: 'LEAD',
    action: 'registerLead',
    sendSignal,
  });
  return response;
};

export const createQuote = async (data = {}, sendSignal) => {
  const resp = await HTTP_REQUEST.post({
    data,
    path: createQuotePath,
    name: 'CORE',
    amplifyType: 'COTIZACION',
    action: 'createQuote',
    sendSignal,
  });
  return resp.payload.payload;
};

export const createQuoteFlex = async (data) => {
  const resp = await HTTP_REQUEST.post({
    data,
    path: createQuotePath,
    name: 'SALFLEX',
    amplifyType: 'SALUD',
    action: 'createQuoteFlex',
  });
  return resp.payload;
};

export const addThirdInQuote = async (data, sendSignal) => {
  const resp = await HTTP_REQUEST.post({
    data,
    path: addThirdPath,
    name: 'CORE',
    amplifyType: 'COTIZACION',
    action: 'addThirdInQuote',
    sendSignal
  });
  return resp;
};

export const validatePreExisting = async (data = {}, sendSignal = () => {}) => {
  const resp = await HTTP_REQUEST.post({
    data,
    path: validatePreExistingPath,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'validatePreExisting',
    sendSignal,
  });
  return resp;
};

export const getDepartaments = async (data = {}, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    data,
    path: getDepartamentsPath,
    name: 'LEAD',
    amplifyType: 'CORE-AMI',
    action: 'getDepartaments',
    sendSignal,
  });
  return response.response.payload;
};

export const getProvinces = async (data = {}) => {
  const response = await HTTP_REQUEST.post({
    path: getProvincesPath,
    data,
    name: 'LEAD',
    amplifyType: 'CORE-AMI',
    action: 'getProvinces',
  });
  return response.response.payload;
};

export const getDistricts = async (data = {}) => {
  const response = await HTTP_REQUEST.post({
    path: getDistrictsPath,
    data,
    name: 'LEAD',
    amplifyType: 'CORE-AMI',
    action: 'getDistricts',
  });
  return response.response.payload;
};

export const selectPlan = async (data, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    path: planSelectionPath,
    data,
    name: 'CORE',
    amplifyType: 'COTIZACION',
    action: 'selectPlan',
    sendSignal,
  });

  return response;
};

export const getSession = async (data, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    path: sessionPath,
    data,
    name: 'CORE',
    amplifyType: 'SALUD',
    action: 'getSession',
    sendSignal
  });
  return response.payload;
};

export const validateSubscriptionDps = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: validateSubscription,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'validateSubscriptionDps',
  });
  return response;
};

export const registerDps = async (data, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    path: registerDpsPath,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'registerDps',
    sendSignal
  });
  return response;
};

export const suscriptionDps = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: susDpsPath,
    data,
    name: 'CORE',
    amplifyType: 'COTIZACION',
    action: 'suscriptionDps',
  });
  return response;
};

export const uploadDps = async (data, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    path: dpsUploadPath,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'uploadDps',
    sendSignal
  });
  return response;
};

export const addRoute = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: dpsRoutePath,
    data,
    name: 'CORE',
    amplifyType: 'COTIZACION',
    action: 'addRoute',
  });
  return response;
};

export const welcomeNotification = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: sendNotificationPath,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'welcomeNotification',
  });
  return response;
};

export const enviarCorreo = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: sendEmailPath,
    data,
    name: 'UTILITARIOS',
    amplifyType: 'CORE-AMI',
    action: 'sendEmail',
  });
  return response;
};

export const sendRequestToEmision = async (data) => {
  const response = await HTTP_REQUEST.post({
    path: sendEmisionPath,
    data,
    name: 'CANALCROSS',
    amplifyType: 'CANALVIDA',
    action: 'sendRequestToEmision',
  });
  return response;
};

export const sendEmailPaymentConfirmation = async (payload) => {
  const { requestEmail, dataToReplace } = payload;
  let html = requestEmail.template;

  Object.keys(dataToReplace).forEach((key) => {
    html = html.replace(new RegExp(`%%${key}%%`, 'g'), dataToReplace[key]);
  });
  requestEmail.template = html;
  return requestEmail;
};

export const calculateDiscount = async (data, sendSignal) => {
  const response = await HTTP_REQUEST.post({
    path: calculatePath,
    data,
    name: 'CORE',
    amplifyType: 'CORE',
    action: 'calculateDiscount',
    sendSignal,
  });
  return response.payload.payload;
};
